import {
  useQuery,
  QueryObserverResult,
  UseQueryOptions
} from '@tanstack/react-query'
import { message } from 'antd'

import { fetchFeedbacks } from '@pepper/utils/src/api/assignments/fetchFeedbacks'

type ReturnType = {
  feedbacks?: Feedbacks | null
  isFeedbacksLoading: boolean
  feedbacksError: Error | null
  refetchFeedbacks: () => Promise<QueryObserverResult<Feedbacks | null>>
}

export const useFeedbackDetails = (
  assignmentId: string,
  params?: { company_id?: string },
  config?: UseQueryOptions<Feedbacks | null, Error>
): ReturnType => {
  const {
    isLoading: isFeedbacksLoading,
    data: feedbacks,
    refetch: refetchFeedbacks,
    error: feedbacksError
  } = useQuery<Feedbacks | null, Error>({
    queryKey: [`/assignments/${assignmentId}/feedback`],
    queryFn: async () => {
      const {
        status,
        data: _feedbacks,
        error: _feedbackError
      } = await fetchFeedbacks(assignmentId, params)

      if (status === 'error') throw new Error(_feedbackError)

      return _feedbacks
    },
    enabled: Boolean(assignmentId),
    onError: _error => message.error(_error.message),
    ...config
  })

  return { feedbacks, isFeedbacksLoading, feedbacksError, refetchFeedbacks }
}
